<template>
  <div class="content-container">
    <div class="panel mt-20 infos-wrapper">
      <div v-if="serviceQuest.id" class="infos">
        <img src="../../assets/logo_leybold_main.png" class="logo-img" />
        <h6 class="mb-20 mt-10">服务请求详情</h6>
        <dl>
          <dt>NCR编号</dt>
          <dd>
            {{ serviceQuest.number
            }}{{ serviceQuest.mode == 8 ? '（此时为业务机会编号）' : '' }}
          </dd>
        </dl>
        <dl style="align-items: center">
          <dt>请求状态</dt>
          <dd class="flex-row">
            <span
              v-if="
                serviceQuest.approval_id > 0 && serviceQuest.approve_index == 0
              "
              class="status-tag-border info"
            >
              审批中
            </span>
            <span v-else class="status-tag-border info">
              {{ ServiceQuestStatusMap[serviceQuest.status] }}
            </span>
          </dd>
        </dl>
        <dl
          v-if="
            serviceQuest.customer.important == 2 && serviceQuest.category == 1
          "
        >
          <dt>紧急程度</dt>
          <dd class="flex-row">
            <span class="level-info text-danger"> 紧急 </span>
          </dd>
        </dl>
        <dl>
          <dt>创建日期</dt>
          <dd>
            {{ formatTime(serviceQuest.created_at, 'YYYY/M/D') }}
          </dd>
        </dl>
        <dl>
          <dt>中间商</dt>
          <dd>
            {{ serviceQuest.dealer.name
            }}{{
              serviceQuest.quest_dealer_contact.name
                ? `（${serviceQuest.quest_dealer_contact.name} ${serviceQuest.quest_dealer_contact.mobile}）`
                : ''
            }}
          </dd>
        </dl>
        <dl>
          <dt>最终客户</dt>
          <dd>
            {{ serviceQuest.customer.name }}
            <span class="text-gray" v-if="serviceQuest.customer.sap_code"
              >（{{ serviceQuest.customer.sap_code }}）</span
            >
            <span v-if="serviceQuest.customer_contact_id"
              >（{{ serviceQuest.customer_contact.name }}
              {{ serviceQuest.customer_contact.mobile }}）
            </span>
            <span
              v-else-if="
                serviceQuest.customer_user.name &&
                !serviceQuest.customer_user.dealer_id
              "
              >（{{ serviceQuest.customer_user.name }}
              {{ serviceQuest.customer_user.mobile }}）
            </span>
          </dd>
        </dl>
        <dl>
          <dt>直销销售</dt>
          <dd v-if="serviceQuest.customer.platform_user_id">
            {{
              serviceQuest.customer.platform_user.name +
              '（' +
              serviceQuest.customer.platform_user.phone_number +
              '）'
            }}
          </dd>
        </dl>
        <dl>
          <dt>电话销售</dt>
          <dd v-if="serviceQuest.customer.telesale_id">
            {{
              serviceQuest.customer.telesale.name +
              '（' +
              serviceQuest.customer.telesale.phone_number +
              '）'
            }}
          </dd>
        </dl>
        <dl>
          <dt>新品销售</dt>
          <dd v-if="serviceQuest.customer.new_product_sale_id">
            {{
              serviceQuest.customer.new_product_sale.name +
              '（' +
              serviceQuest.customer.new_product_sale.phone_number +
              '）'
            }}
          </dd>
        </dl>
        <dl>
          <dt>客户设备</dt>
          <dd>
            <span>{{ serviceQuest.device.serial_number }}，</span>
            <span>{{ serviceQuest.device.equipment_number }}，</span>
            <span>
              {{
                serviceQuest.device.item_category.whole_name.replace(/,/g, '-')
              }}，
            </span>
            <span>{{ serviceQuest.device.machine_type }}</span>
          </dd>
        </dl>
        <dl>
          <dt>设备地址</dt>
          <dd>
            <span>{{ serviceQuest.device.address.whole_name }}</span>
          </dd>
        </dl>
        <dl>
          <dt>需求类型</dt>
          <dd>
            {{ serviceQuest.cmm_category }}
          </dd>
        </dl>
        <dl>
          <dt>问题分类</dt>
          <dd>
            {{ serviceQuest.sub_category }}
          </dd>
        </dl>
        <dl>
          <dt>详细描述</dt>
          <dd>
            <div v-html="serviceQuest.desc"></div>
            <div
              class="desc-img"
              v-if="serviceQuest.desc_imgs && serviceQuest.desc_imgs.length > 0"
            >
              <auth-img
                tag="el-image"
                v-for="item in serviceQuest.desc_imgs"
                :preview-src-list="serviceQuest.desc_imgs"
                :key="item"
                :src="item"
                fit="cover"
                style="width: 40px; height: 40px; margin-right: 4px"
              ></auth-img>
            </div>
          </dd>
        </dl>
        <dl v-if="serviceQuest.hs2">
          <dt>HS2 申明</dt>
          <dd class="text-primary pointer" @click="showHS2 = true">点击查看</dd>
        </dl>
        <dl v-if="serviceQuest.logistics_number">
          <dt>物流信息</dt>
          <dd>
            {{ serviceQuest.logistics_number }}（{{
              serviceQuest.logistics_company
            }}）
          </dd>
        </dl>
        <template
          v-if="serviceQuest.mode_status > 1 || serviceQuest.status == 100"
        >
          <dl>
            <dt class="text-black font-bold mt-10">评估方案</dt>
          </dl>
          <dl>
            <dt>处理方式</dt>
            <dd>
              {{ ServiceQuestMode[serviceQuest.mode] }}
            </dd>
          </dl>
          <dl>
            <dt>OEM厂商</dt>
            <dd v-if="serviceQuest.oem_id > 0">
              <div>
                {{ serviceQuest.oem.name }}
                <span class="text-gray" v-if="serviceQuest.oem_sap_code"
                  >（{{ serviceQuest.oem_sap_code }}）</span
                >
                <span v-if="serviceQuest.dealer_contact.name"
                  >（{{ serviceQuest.dealer_contact.name }}
                  {{ serviceQuest.dealer_contact.mobile }}）
                </span>
              </div>
            </dd>
          </dl>
          <dl>
            <dt>设备号</dt>
            <dd>
              {{ serviceQuest.product_number }}
            </dd>
          </dl>
          <dl>
            <dt>发货日期</dt>
            <dd>
              {{ serviceQuest.delivery_date }}
            </dd>
          </dl>
          <dl>
            <dt>保修类型</dt>
            <dd>
              {{ serviceQuest.warranty_type }}
            </dd>
          </dl>
          <!-- <dl>
            <dt>FSE现场检测</dt>
            <dd>
              {{ serviceQuest.fse_testing }}
            </dd>
          </dl> -->
          <dl>
            <dt>新品销售</dt>
            <dd>
              {{ serviceQuest.new_product_sale.name }}
            </dd>
          </dl>
          <dl>
            <dt>生产工厂</dt>
            <dd>
              {{ serviceQuest.factory }}
            </dd>
          </dl>
        </template>
        <template v-if="serviceQuest.category == 2 && serviceQuest.mode != 0">
          <dl>
            <dt>收购价格</dt>
            <dd>{{ serviceQuest.quoted_price }}元</dd>
          </dl>
          <dl>
            <dt>维修成本</dt>
            <dd>{{ serviceQuest.maintenance_cost }}元</dd>
          </dl>
        </template>
        <!-- <div
          @click="unfold = !unfold"
          class="unfold"
          v-if="serviceQuest.mode_status > 1 || serviceQuest.status == 100"
        >
          {{ unfold ? '收起' : '展开更多信息' }}
        </div> -->
      </div>
    </div>
    <div class="panel mt-20">
      <div
        class="header mobile-header"
        style="display: flex; position: relative"
      >
        <h2 style="min-width: 100px">处理流程</h2>
        <div class="flow-container" id="flow-container">
          <div class="flows" style="flex: 1">
            <el-steps
              ref="flowStep"
              :active="flowIndex"
              finish-status="success"
              :space="200"
            >
              <el-step
                v-for="(status, index) in steps"
                :title="ServiceQuestModeStatus[status]"
                :key="index"
              >
              </el-step>
            </el-steps>
          </div>
          <div class="times">
            <div v-for="(time, index) in times">
              <span v-if="index < flowIndex">
                {{ formatTime(time, 'YYYY-MM-DD HH:mm') }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="panel mt-10"
      v-if="serviceQuest.responses && serviceQuest.responses.length > 0"
    >
      <div class="timeline-cell" v-for="(res, index) in serviceQuest.responses">
        <div
          class="line-y"
          v-if="index < serviceQuest.responses.length - 1"
        ></div>
        <div class="node">{{ ServiceQuestModeStatus[res.category] }}</div>
        <div class="content">
          <div class="card">
            <div class="flex-row name-info">
              <span class="font-12 text-primary">{{ res.user.name }}</span>
              <span class="text-info-12 ml-10">{{
                formatTime(res.created_at, 'YYYY-MM-DD HH:mm')
              }}</span>
            </div>
            <div class="desc">
              <div v-if="res.status == 1">
                完成 {{ ServiceQuestModeStatus[res.category] }}
              </div>
              <div v-if="res.category == 98">
                回滚到：{{ ServiceQuestModeStatus[parseInt(res.desc)] }}
              </div>
              <div v-if="res.category == 111">
                <div v-html="res.desc"></div>
                <div
                  class="mb-5"
                  v-if="res.form_data && res.form_data.products"
                >
                  备件清单
                </div>
                <el-table
                  :data="res.form_data.products"
                  v-if="res.form_data && res.form_data.products"
                  border
                  size="small"
                  style="width: 100%; max-width: 1000px"
                >
                  <el-table-column prop="name" label="件号" min-width="120">
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.part_number }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="描述" min-width="220">
                    <template slot-scope="scope">
                      <span>{{ scope.row.description }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="count" label="数量" align="center">
                  </el-table-column>
                </el-table>
              </div>
              <div v-else>
                <div v-for="item in res.form_data">
                  {{ item.name }}：{{ item.value }}
                </div>
                <div v-html="res.desc"></div>
              </div>
            </div>
            <div class="attachements" v-if="res.files && res.files.length > 0">
              <div class="text-info-12">
                <i class="el-icon-paperclip"></i>
                附件
              </div>
              <div class="file-item text-primary" v-for="file in res.files">
                <i
                  :class="
                    isImage(file.url)
                      ? 'el-icon-picture-outline'
                      : 'el-icon-files'
                  "
                ></i>
                <a :href="host + file.url" :download="file.name">{{
                  file.name
                }}</a>
                <span
                  class="pointer preview"
                  v-if="canPreviewFile(file.url)"
                  @click="filePreview(host + file.url)"
                  >预览</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hs-former :show.sync="showHS2" :model="serviceQuest.hs2"></hs-former>
  </div>
</template>
<script>
import { serviceQuestShareDetail } from '../../service/getData'
import { formatTime, canPreviewFile, isImage } from '@/util/index'
import HsFormer from './hs2_preview'
import VueClipboards from 'vue-clipboards'
import Vue from 'vue'
Vue.use(VueClipboards)

import {
  ServiceQuestStatusMap,
  ServiceQuestModeStatus,
  ServiceQuestFlow,
  ServiceQuestMode,
} from '@/config/global.js'
import { isMobile } from '@/util'

export default {
  components: {
    HsFormer,
  },
  data() {
    return {
      showHS2: false,
      formatTime,
      ServiceQuestStatusMap,
      id: 0,
      serviceQuest: {},
      ServiceQuestModeStatus,
      ServiceQuestMode,
      ServiceQuestFlow,
      isImage: isImage,
      canPreviewFile: canPreviewFile,
      times: [],
    }
  },
  computed: {
    steps() {
      if (this.serviceQuest.id > 0) {
        let defaults = ServiceQuestFlow[this.serviceQuest.mode].map((item) => {
          return item
        })
        if (this.serviceQuest.status == 3) {
          defaults.push(99)
        }
        return defaults
      } else {
        return []
      }
    },
    flowIndex() {
      let steps = this.steps
      if (this.serviceQuest.status == 3) {
        return -1
      }
      return steps.indexOf(this.serviceQuest.mode_status)
    },
  },
  created() {
    this.requestServiceQuest()
  },
  methods: {
    async requestServiceQuest() {
      let res = await serviceQuestShareDetail(this.$route.params.uuid)
      this.serviceQuest = res.data
      this.computeTimes()

      if (isMobile()) {
        this.$nextTick(() => {
          document.querySelector('#flow-container').scrollLeft =
            this.flowIndex > 0 ? (this.flowIndex - 1) * 150 : 0
        })
      }
    },
    computeTimes() {
      var timeMap = {}
      this.serviceQuest.responses.map((item) => {
        if (item.status == 1) {
          timeMap[item.category] = item
        }
      })
      var times = []
      for (let index = 0; index < this.steps.length; index++) {
        const step = this.steps[index]
        if (step == 0) {
          times.push(this.serviceQuest.created_at)
        } else {
          if (timeMap[step]) {
            times.push(timeMap[step].created_at)
          } else {
            times.push('')
          }
        }
      }
      this.times = times
    },
    filePreview(file) {
      if (!file) return
      window.open(file, '_blank')
      return
    },
  },
}
</script>

<style scoped>
.infos dl {
  display: flex;
  font-size: 12px;
  margin-bottom: 8px;
}
.infos dl dd {
  margin-bottom: 0;
}
.infos dl dt {
  width: 70px;
  min-width: 70px;
  color: #bec4cb;
  font-weight: 400;
}
.level-info {
  display: flex;
  align-items: center;
}
.level-info i {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-right: 5px;
}
.flows span {
  color: #aaa;
}
.flows i {
  margin: 0 5px;
}
.flows span.current {
  color: #047bf8;
}
.flows span.before {
  color: #047bf88c;
}
.unfold {
  font-size: 12px;
  color: #047bf8;
  text-decoration: underline;
  margin-top: 10px;
  cursor: pointer;
  padding-left: 100px;
}
.user-info .avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  overflow: hidden;
  margin-right: 20px;
}
.user-info .name {
  font-size: 14px;
  margin-bottom: 2px;
}
.user-info .avatar img {
  width: 100%;
  height: 100%;
}
.user-info .date {
  text-align: right;
}
.user-info {
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
  font-size: 12px;
}

.infos-wrapper {
  display: flex;
  justify-content: space-between;
  position: relative;
}
#sr-form >>> label.el-form-item__label,
#sr-form >>> .el-radio__label {
  font-size: 12px !important;
}

/deep/.ql-editor {
  min-height: 100px;
}
/deep/.ql-formats {
  line-height: 0;
}
.times {
  /* padding-left: 100px; */
  display: flex;
  margin-top: 10px;
}
.times div {
  flex: 1;
  max-width: 200px;
  font-size: 12px;
  color: #999;
  /* text-align: center; */
}
.preview-steps {
  font-size: 12px;
  color: #888;
  display: flex;
  flex-wrap: wrap;
  line-height: 1.5em;
  margin-top: 10px;
}
.preview-steps .arrow {
  margin: 0 4px;
}
.timeline-cell {
  position: relative;
}
.timeline-cell .line-y {
  position: absolute;
  bottom: -6px;
  top: 34px;
  left: 49px;
  background-color: #047bf8;
  width: 1px;
  z-index: 99;
}

.timeline-cell .node {
  position: absolute;
  top: 6px;
  left: 0;
  width: 100px;
  height: 28px;
  line-height: 28px;
  border: 1px solid #047bf8;
  background-color: #aac9eb6e;
  color: #047bf8;
  font-size: 12px;
  text-align: center;
  z-index: 999;
  border-radius: 4px;
}
.timeline-cell .content {
  margin-left: 120px;
  padding-bottom: 10px;
  padding-top: 6px;
  border-bottom: 1px solid #f0f0f0;
}

.timeline-cell .name-info {
  line-height: 28px;
}

.timeline-cell .content .attachements {
  padding-top: 10px;
  font-size: 12px;
}
.timeline-cell .content .attachements .file-item {
  margin-top: 10px;
}
.timeline-cell .content .attachements .file-item i {
  margin-right: 5px;
}
.timeline-cell .content .attachements .file-item .preview {
  opacity: 0;
  margin-left: 40px;
}
.timeline-cell .content .attachements .file-item:hover .preview {
  opacity: 1;
}
.timeline-cell .desc {
  font-size: 14px;
  line-height: 1.5;
}
#sr-form .el-input,
#sr-form .el-select {
  width: 100% !important;
}
.evalaute-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.evalaute-wrapper .el-form-item {
  width: 48%;
}
.flex-row {
  align-items: center;
}
.desc-img {
  display: flex;
  flex-wrap: wrap;
  margin-top: 6px;
  margin-bottom: 6px;
}
.flow-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.font-bold {
  font-weight: bold !important;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
}

.logo-img {
}
</style>
